import $ from 'jquery';
import Swiper from 'swiper';
import isViewport from '../../scripts/util/window/isViewport';
import {mid, lg} from '../../scripts/util/window/isViewport';


export default class Alphabet {
	constructor(options) {
		const defaults = {
			el: '.js-alphabet',
			dom: {
				slider: '.js-alphabet-slider',
				sliderSubscribes: '.js-alphabet-slider-subscribes',
				letter: '.js-letter'
			},
			classes: {
				letter: {
					state: {
						active: 'alphabet__letter_state_active'
					}
				}
			}
		};

		this.Slider = null;
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$slider = this.$el.find(this.options.dom.slider);
		this.$sliderSubscribes = this.$el.find(this.options.dom.sliderSubscribes);
		this.$letter = this.$el.find(this.options.dom.letter);
	}

	initSlider() {
		if (isViewport(mid) && this.$slider.length) {
			this.Slider = new Swiper(this.$slider, {
				slidesPerView: 'auto',
				observer: true,
				observeParents: true,
				nextButton: '.alphabet__arrow_type_next',
				prevButton: '.alphabet__arrow_type_prev'
			});
		} else if (isViewport(lg) && this.$sliderSubscribes.length) {
			this.Slider = new Swiper(this.$sliderSubscribes, {
				slidesPerView: 'auto',
				observer: true,
				observeParents: true,
				nextButton: '.alphabet__arrow_type_next',
				prevButton: '.alphabet__arrow_type_prev'
			});
		} else if (this.Slider) {
			this.Slider.destroy(true, true);
			this.Slider = null;
		}
	}

	setActiveLetter(e) {
		const $target = $(e.target);
		this.$letter.removeClass(this.options.classes.letter.state.active);
		$target.addClass(this.options.classes.letter.state.active);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.initSlider();
			console.log(this);

			$(window).resize(() => {
				this.initSlider();
			});

			this.$letter.on('click', this.setActiveLetter.bind(this));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/alphabet/alphabet.js
 **/